<form [formGroup]="formationForm" (ngSubmit)="onSubmit()" class="space-y-6">

  <div class="flex flex-col gap-2">
    <label class="font-medium">Titre</label>
    <input formControlName="title" type="text" class="p-2 border rounded w-full md:w-2/3 text-[16px]" />
    <span *ngIf="formationForm.get('title')?.invalid && formationForm.get('title')?.touched"
      class="text-red-500 text-sm">
      Titre obligatoire (min 2 caractères)
    </span>
  </div>

  <div class="flex flex-col gap-2">
    <label class="font-medium">Description</label>
    <textarea formControlName="description" rows="4" class="p-2 border rounded w-full md:w-2/3"></textarea>
  </div>

  <div class="flex flex-col gap-2">
    <label class="font-medium">Prix (€)</label>
    <input formControlName="price_eur" type="number" class="p-2 border rounded w-full md:w-1/3 text-[16px]" />
    <span *ngIf="formationForm.get('price_eur')?.invalid && formationForm.get('price_eur')?.touched"
      class="text-red-500 text-sm">
      Prix obligatoire (>= 0)
    </span>
  </div>

  <div class="flex items-center gap-2">
    <input type="checkbox" formControlName="is_active" />
    <label class="font-medium">Active</label>
  </div>

  <div class=" rounded p-4 space-y-4 ">
    <label class="font-medium">Image de la formation</label>
    <div *ngIf=" isEditMode && formationForm.value.image_url" class="mb-3">
      <p class="text-sm mb-1">Image actuelle :</p>
      <img [src]="formationForm.value.image_url" alt="Image formation" class="w-48 h-auto rounded border" />
    </div>
    <p-fileupload #imageUploader [customUpload]="true" (onSelect)="onSelectImage($event)" [multiple]="false"
      accept="image/*" mode="basic">
    </p-fileupload>
    <span *ngIf="formationForm.get('image_url')?.invalid && formationForm.get('image_url')?.touched"
      class="text-red-500 text-sm">
      Image obligatoire
    </span>
  </div>
  <div class=" rounded p-4 space-y-4 ">
    <label class="font-medium">Fichier pdf de la formation</label>
    <div *ngIf=" isEditMode && formationForm.value.pdf_file" class="mb-3">
      <a [href]="pdfUrl" target="_blank">📄 Voir le PDF actuel</a>
    </div>

    <p-fileupload #pdfUploader (onSelect)="onSelectPdf($event)" [multiple]="false" accept="application/pdf"
      mode="basic">
    </p-fileupload>
    <span *ngIf="formationForm.get('pdf_file')?.invalid && formationForm.get('pdf_file')?.touched"
      class="text-red-500 text-sm">
      Pdf obligatoire
    </span>
  </div>

  <div class="text-center mt-6">
    <p-button type="submit" [label]="isEditMode ? 'Mettre à jour la formation' : 'Créer la formation'"
      [disabled]="!isEditMode && formationForm.invalid">
    </p-button>
  </div>

</form>